module.exports = "<div class=\"<%= gwGtpPresentationArea %>\">\r\n    <img src=\"{{getCustomImage($ctrl.selectedOccupation.code)}}\">\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/guidance/common/directives/MediaArea/GuidanceMediaArea.html
// module id = 504
// module chunks = 0